import { IonAccordion, IonAccordionGroup, IonBackButton, IonButton, IonButtons, IonCard, IonCardContent, IonCardHeader, IonCardSubtitle, IonCardTitle, IonChip, IonCol, IonContent, IonGrid, IonHeader, IonIcon, IonImg, IonInput, IonInputPasswordToggle, IonItem, IonLabel, IonList, IonMenuButton, IonNote, IonPage, IonRow, IonSelect, IonSelectOption, IonText, IonTitle, IonToggle, IonToolbar, ToggleCustomEvent, useIonAlert, useIonLoading, useIonRouter, useIonToast, useIonViewDidEnter, useIonViewDidLeave, useIonViewWillEnter } from '@ionic/react';
import React, { useEffect, useRef, useState } from 'react';
import { useAppContext } from '../AppProvider';
import { Link } from 'react-router-dom';
import { Preferences } from '@capacitor/preferences';
import './Settings.css';
import { cardOutline, discSharp, optionsOutline, refreshCircleOutline, refreshOutline } from 'ionicons/icons';
import { Capacitor } from '@capacitor/core';
import { Device } from '@capacitor/device';
import { Network } from '@capacitor/network';
import PlanCards from '../components/PlanCards';
import { VAPID_PUBLIC_KEY, urlBase64ToUint8Array } from '../lib/PushClient';

const Settings: React.FC = () => {
    const [disableReset, setDisableReset] = useState<boolean>(true);
    const [resetVerified, setResetVerified] = useState<boolean>(false);
    const [disableDelete, setDisableDelete] = useState<boolean>(true);

    const [appStatusColor, setAppStatusColor] = useState<string>('');
    const [networkType, setNetworkType] = useState<string>('Unknown');
    //const [networkStatus, setNetworkStatus] = useState<boolean>(false);
    const [networkStatusColor, setNetworkStatusColor] = useState<string>('');
    const [model, setModel] = useState<string>('Unknown');
    const [os, setOs] = useState<string>('Unknown');

    const [levelOpen, setLevelOpen] = useState<boolean>(false);
    
    // Push notifications
    const [sub, setSub] = useState<PushSubscription | null>(null);
    const [error, setError] = useState<string | null>(null);
    
    const { networkStatus, setNetworkStatus, appStatus, getAppStatus, authKey, authenticateMember, authorizedMember, getAuthorizedMember, loading, setShowLoader, level, levels, getLevels, limits, settings, getSettings, setActivePartners, setAuthKey, setAuthorizedMember, setAvailableContacts, setAvailableKids, setAvailablePets, setCheckedContacts, setContacts, setEndPlaces, setKids, setPets, setPlaces, setRoutes, setPendingPartners, setSelectedVehiclesEnd, setSelectedVehiclesEnroute, setSelectedVehiclesStart, setStartPlaces, setVehicles, setVehiclesAll, setVehiclesEnd, setVehiclesEnroute, setVehiclesStart, setSettings, locationPerm, setLocationPerm, locationPermStr, setLocationPermStr, pushPermStr, setPushPermStr, textLogoLoaded, fadeInTextLogo, SWTextLogo, SWFullHorizLogo, SWTextDarkLogo,clearAllCookies } = useAppContext();         
    
    const accordionGroup = useRef<null | HTMLIonAccordionGroupElement>(null);   
    const passcodeVerifyBtn = useRef<any>();
    const passcodeVerifyInput = useRef<any>();
    const passcodeInput = useRef<any>();
    const deleteInput = useRef<any>();
    const deleteVerify = useRef<any>();
    const accountDelete = useRef<any>();
    const deleteLocsBtn = useRef<any>();

    const [showAlert] = useIonAlert();
    const [showToast] = useIonToast();
    const router = useIonRouter();
    const platform = Capacitor.getPlatform();
    

    //
    // Authenticate Member
    //
    useIonViewWillEnter(() => {
        setShowLoader(true);

        const authenticate = async () => {
            const appstat = await getAppStatus();
            if (!networkStatus && appstat === 'No') {
                router.push('/connection', 'forward');
            } else {
                const authenticated = await authenticateMember();   
                if(!authenticated || authenticated.mt == '') router.push('/login', 'forward');
                else {
                    checkPushSub();
                    await getLevels(authenticated.mt);                
                    const params = new URLSearchParams(window.location.search);

                    await getDeviceInfo();
                    await getNetworkStatus();
                    
                    if(params.has('level')) setLevelOpen(true);                
                    setShowLoader(false);
                }
            }
        };
        authenticate();
    }); 


    useEffect(() => {
        setNetworkStatusColor(networkStatus ? 'success' : 'danger');
    }, [networkStatus]);


    useEffect(() => {
        let color = '';
        switch (appStatus) {
            case 'No':
                color = 'danger';
                break;

            case 'Slow':
                color = 'warning';
                break;

            case 'Fast':
                color = 'success';
                break;
        }
        setAppStatusColor(color);
    }, [appStatus]);


    useIonViewDidLeave(() => {
        setLevelOpen(false);
    });


    //
    // Get Network Status
    //
    const getNetworkStatus = async () => {
        const status = await Network.getStatus();
        setNetworkStatus(status.connected);
        setNetworkStatusColor(status.connected ? 'success' : 'danger');
        setNetworkType(status.connectionType);
    };


    //
    // Get Device Info
    //
    const getDeviceInfo = async () => {
        const deviceInfo = await Device.getInfo();
        setModel(deviceInfo.model);
        setOs(deviceInfo.osVersion);
    };


    // Add or remove the "dark" class on the document body
    const toggleTheme = (shouldAdd: boolean) => {
        document.body.classList.toggle('dark', shouldAdd);
    };  


    // Push Notification functions -- Start
    const askPermission = async () => {
        if (!('Notification' in window)) {
            console.warn('Notifications API not supported in this browser.');
            return;
        }
        const result = await Notification.requestPermission();
        console.log('[app] Notification permission:', result);
    };

    const subscribe = async () => {
        setError(null);
        try {
            if (!('serviceWorker' in navigator)) throw new Error('No service worker support');
            if (!('PushManager' in window)) throw new Error('No PushManager support');

            const permission = Notification.permission;
            if (permission !== 'granted') throw new Error(`Permission is ${permission}`);

            const reg = await navigator.serviceWorker.getRegistration();
            if (!reg) throw new Error('No SW registration');

            // If already subscribed, reuse it
            const existing = await reg.pushManager.getSubscription();
            if (existing) {
                //console.log('[app] existing subscription:', JSON.stringify(existing.toJSON(), null, 2));
                setSub(existing);
                return;
            }

            const appServerKey = urlBase64ToUint8Array(VAPID_PUBLIC_KEY);
            const newSub = await reg.pushManager.subscribe({
                userVisibleOnly: true,
                applicationServerKey: appServerKey,
            });

            //console.log('[app] new subscription:', JSON.stringify(newSub.toJSON(), null, 2));
            setSub(newSub);

            const subJson = newSub.toJSON();

            // post to database
            const body = authKey.mt != null ? { ...subJson, mt: authKey.mt } : subJson;
            
            try {
                const res = await fetch('https://api.besolowise.com/web-push/subscribe/', {
                    method: 'POST',
                    credentials: 'include',
                    body: JSON.stringify(body),
                });
                
                if (!res.ok) {
                    //console.log('!ok'); 
                    const text = await res.text().catch(() => '');
                    throw new Error(`subscribe.php failed: ${res.status} ${res.statusText} – ${text}`);
                } else {
                    const obj = await res.json();    
                    //console.log(obj);                    
                    return obj; // { ok, stored, updated, endpoint }
                }

            } catch(error) {
                //console.error(error);
                showToast({
                    message: 'Connection: ' + error + '',
                    duration: 2000,
                    color: 'danger',
                    position: 'bottom',
                });
            } 
            
        } catch (e: any) {
            console.error('[app] subscribe error:', e);
            setError(e?.message || String(e));
        }
    };

    const checkPushSub = async () => {
        const reg = await navigator?.serviceWorker?.getRegistration();
        const existing = await reg?.pushManager.getSubscription();
        //console.log('[app] check existing:', existing?.toJSON?.());
        setSub(existing ?? null);
    };

    const unsubscribe = async () => {
        const reg = await navigator.serviceWorker.getRegistration();
        const existing = await reg?.pushManager.getSubscription();
        if (existing) {
            const ok = await existing.unsubscribe();
            //console.log('[app] unsubscribed?', ok);
            localStorage.removeItem('pushSub');

            const subJson = existing.toJSON();

            // post to database
            const body = authKey.mt != null ? { ...subJson, mt: authKey.mt } : subJson;
            
            try {
                const res = await fetch('https://api.besolowise.com/web-push/unsubscribe/', {
                    method: 'POST',
                    credentials: 'include',
                    body: JSON.stringify(body),
                });
                //console.log(res); 
                if (!res.ok) {
                    console.log('!ok'); 
                    const text = await res.text().catch(() => '');
                    throw new Error(`unsubscribe.php failed: ${res.status} ${res.statusText} – ${text}`);
                } else {
                    const obj = await res.json();    
                    //console.log(obj);                    
                    return obj; // { ok, stored, updated, endpoint }
                }

            } catch(error) {
                console.error(error);
                showToast({
                    message: 'Connection: ' + error + '',
                    duration: 2000,
                    color: 'danger',
                    position: 'bottom',
                });
            } 

            setSub(null);
        }
    };
    // Push Notification functions -- End


    //
    // Delete all saved locations
    //
    const deleteLocations = async () => {
        deleteLocsBtn.current.disabled = true;
        const formData = new FormData(); 
        formData.append('mt', authKey.mt);
        try {
            const apiURI = 'https://api.besolowise.com/tracks/delete/';
            const response = await fetch(apiURI, {
                method: 'POST',
                credentials: 'include',
                body: formData
            });
            if(response.ok) {
                const obj = await response.json();                 
                if(obj.success) {
                    
                    
                } else {
                    showToast({
                        message: 'Data Error: Delete failed. Try again.',
                        duration: 2000,
                        color: 'danger',
                        position: 'bottom',
                    });
                }
            } else {
                showToast({
                    message: 'Response Error. Try again.',
                    duration: 2000,
                    color: 'danger',
                    position: 'bottom',
                });  
            }  
             
        } catch(error) {
            showToast({
                message: 'Connection: ' + error + '.',
                duration: 2000,
                color: 'danger',
                position: 'bottom',
            });
        } 
        deleteLocsBtn.current.disabled = false; 
    };


    //
    // Update Setting
    //
    const updateSetting = async (e:any) => {
        e.preventDefault();
        const elemId = e.target.id;
        let elemVal:any = false;
        if(elemId == 'themeToggle') {
            elemVal = e.detail.checked;
            toggleTheme(elemVal);
            elemVal = elemVal ? '1' : '0'
        } else if(elemId == 'geoLocToggle' || 
                  elemId == 'searchableToggle' || 
                  elemId == 'smsToggle') {
            elemVal = e.detail.checked;
            elemVal = elemVal ? '1' : '0';
            //console.log(elemVal);
        } else if(elemId == 'menuKidsToggle' || 
                  elemId == 'menuPartnersToggle' || 
                  elemId == 'menuPetsToggle' ||
                  elemId == 'menuPlacesToggle' || 
                  elemId == 'menuVehiclesToggle') {
            elemVal = e.detail.checked;
            elemVal = elemVal ? '1' : '0';
        } else if(elemId == 'passwordSet') {
            e.target.innerHTML = 'Saving...';
            e.target.setAttribute('disabled', '');
            elemVal = passcodeInput.current.value;            
        } else {
            elemVal = e.detail.value;
        }
        
        const formData = new FormData(); 
        formData.append('updateElement', elemId);
        formData.append('updateValue', elemVal);
        formData.append('mt', authKey.mt);
        try {
            const apiURI = 'https://api.besolowise.com/members/settings/update/';
            const response = await fetch(apiURI, {
                method: 'POST',
                credentials: 'include',
                body: formData
            });
            if(response.ok) {
                const obj = await response.json();                 
                if(obj.success) {
                    //setLevelOpen(false);
                    //const params = new URLSearchParams(window.location.search);
                    //if(params.has('level')) setLevelOpen(true);

                    if(elemId == 'passwordSet') {
                        passcodeVerifyInput.current.value = '';
                        passcodeInput.current.value = '';
                        e.target.innerHTML = 'Save';
                        e.target.removeAttribute('disabled');
                        setResetVerified(false);
                        passcodeVerifyBtn.current.disabled = false;
                        showToast({
                            message: 'SAVED. Your passcode was reset.',
                            duration: 3000,
                            color: 'success',
                        });
                        memberLogOut();
                    }
                    getAuthorizedMember(obj.mt);
                    getSettings(obj.mt);
                    
                } else {
                    showToast({
                        message: 'Data Error: Changes were not saved. Try again.',
                        duration: 2000,
                        color: 'danger',
                    });
                }
            } else {
                showToast({
                    message: 'Response Error. Try again.',
                    duration: 2000,
                    color: 'danger',
                });  
            }  
             
        } catch(error) {
            showToast({
                message: 'Connection: ' + error + '.',
                duration: 3000,
                color: 'danger'
            });
        }        
    };

    {/*const confirmPlanChange = (id:number, changeText:string) => {
        showAlert({
            header: 'Confirm!',
            message: 'Are you sure you want to ' + changeText.toUpperCase() + ' your ACCOUNT PLAN?',
            buttons: [
                { 
                  text: 'Cancel', 
                  role: 'cancel',
                  cssClass: 'alert-button-cancel'
                },
                {
                    text: changeText.toUpperCase(),
                    role: 'confirm',
                    cssClass: 'alert-button-confirm',
                    handler: async () => {
                        router.push('/account/payment/?l=' + id, 'forward');
                    }
                }
            ]
        })        
    };*/}

    const validateReset = () => {       
        const passcode = passcodeInput.current.value;
        const disable = (passcode.length < 8 );       
        setDisableReset(disable);
    };

    const confirmPasscodeReset = (e:any) => {
        showAlert({
            header: 'Confirm!',
            message: 'Are you sure you want to RESET your PASSCODE? You will be logged-out and will need to log-in again.',
            buttons: [
                { text: 'Cancel', role: 'cancel' },
                {
                    text: 'Reset',
                    handler: async () => {
                        updateSetting(e);
                    }
                }
            ]
        })        
    };

    const verifyReset = async () => {
        passcodeVerifyInput.current.disabled = true;
        passcodeVerifyBtn.current.disabled = true;
        const formData = new FormData(); 
        formData.append('passcode', passcodeVerifyInput.current.value);   
        formData.append('mt', authKey.mt);         
        try {
            const response = await fetch('https://api.besolowise.com/members/authenticate/verify/', {
                method: 'POST',
                credentials: 'include',
                body: formData
            });
            if(response.ok) {
                const obj = await response.json(); 
                
                if(obj.success) {
                    //setDisablePasscodeInput(false);
                    //passcodeInput.current.focus;
                    setResetVerified(true);
                } else {
                    passcodeVerifyInput.current.disabled = false;
                    passcodeVerifyBtn.current.disabled = false;
                    showToast({
                        message: 'Invalid passcode. Try again.',
                        duration: 2000,
                        color: 'danger',
                    });
                }
            } else {
                showToast({
                    message: 'Response Error. Try again.',
                    duration: 2000,
                    color: 'danger'
                });  
            } 
        } catch(error) {
            showToast({
                message: 'Connection Error: ' + error + '. Try again.',
                duration: 3000,
                color: 'danger'
            });
        }
    };


    //
    // Tech Info
    //

    const formatPlatform = (platform: string) => {
        if(platform === 'web') return 'Web'; 
        if(platform === 'android') return 'Android'; 
        if(platform === 'ios') return 'iOS'; 
    }


    //;
    // Member Log-out
    //
    const memberLogOut = async () => {       
        setShowLoader(true);
        try {
            const formData = new FormData();
            formData.append('mt', authKey.mt);
            const response = await fetch('https://api.besolowise.com/members/authenticate/signout/', {
                method: 'POST',
                credentials: 'include',
                body: formData
            });
            if(response.ok) {
                
                const obj = await response.json();
                await Preferences.remove({key: 'solowise'});   
                //await clearAllCookies(); // Now done server-side
                setAuthKey({});
                setActivePartners({});
                setAuthorizedMember({});
                setAvailableContacts({});
                setAvailableKids({});
                setAvailablePets({});
                setCheckedContacts({});
                setContacts({});
                setKids({});
                setPendingPartners({});
                setPets({});
                setPlaces({});
                setRoutes({});
                setSelectedVehiclesEnd({});
                setSelectedVehiclesEnroute({});
                setSelectedVehiclesStart({});
                setSettings({});
                setStartPlaces({});
                setVehicles({});
                setVehiclesAll({});
                setVehiclesEnd({});
                setVehiclesEnroute({});
                setVehiclesStart({});
                //document.body.classList.add('dark');
                setTimeout(async () => {
                    //setShowLoader(false);
                    router.push('/', 'forward');
                }, 2000);                                
            } else {
                setShowLoader(false);
                showToast({
                    message: 'Log-out Error',
                    duration: 2000,
                    color: 'warning',
                    position: 'middle'
                });
            }
        } catch(error) {
            setShowLoader(false);
            showToast({
                message: 'Log-out Error: ' + error,
                duration: 2000,
                color: 'warning',
                position: 'middle'
            });
        }                     
    };
    
    const verifyDelete = async () => {
        deleteInput.current.disabled = true;
        deleteVerify.current.disabled = true;
        const formData = new FormData(); 
        formData.append('passcode', deleteInput.current.value);
        formData.append('mt', authKey.mt);       
        try {
            const response = await fetch('https://api.besolowise.com/members/authenticate/verify/', {
                method: 'POST',
                credentials: 'include',
                body: formData
            });
            if(response.ok) {
                const obj = await response.json(); 
                
                if(obj.success) {
                    setDisableDelete(false);
                } else {
                    deleteInput.current.disabled = false;
                    deleteVerify.current.disabled = false;
                    showToast({
                        message: 'Invalid passcode. Try again.',
                        duration: 2000,
                        color: 'danger',
                    });
                }
            } else {
                showToast({
                    message: 'Response Error. Try again.',
                    duration: 2000,
                    color: 'danger'
                });  
            } 
        } catch(error) {
            showToast({
                message: 'Connection Error: ' + error + '. Try again.',
                duration: 3000,
                color: 'danger'
            });
        }
    };

    const deleteAccount = async () => {
        setDisableDelete(true);
        try {
            const formData = new FormData(); 
            formData.append('mt', authKey.mt);
            const response = await fetch('https://api.besolowise.com/members/delete/', {
                method: 'POST',
                credentials: 'include',
                body: formData
            });
            
            if(response.ok) {
                const obj = await response.json(); 
                //console.log(obj);
                if(obj.success) {
                    await memberLogOut();
                } else {
                    setDisableDelete(false);
                    showToast({
                        message: 'An unusual error occurred. Try again.',
                        duration: 3000,
                        color: 'danger',
                    });
                }
            } else {
                setDisableDelete(false);
                showToast({
                    message: 'Response Error. Try again.',
                    duration: 3000,
                    color: 'danger',
                    position: 'middle'
                });  
            } 
        } catch(error) {
            setDisableDelete(false);
            showToast({
                message: 'Connection Error: ' + error + '. Try again.',
                duration: 3000,
                color: 'danger',
                position: 'middle'
            });
        }
    };

    return (
        <IonPage>
            <IonHeader>
                <IonToolbar>
                    <IonButtons slot='start'>
                        <IonBackButton color={'tertiary'}>Back</IonBackButton>
                    </IonButtons>
                    <IonTitle><IonImg className={textLogoLoaded ? 'fade-in' : 'fade-out'} src={settings.theme == '1' ? SWTextDarkLogo : SWFullHorizLogo} onIonImgDidLoad={fadeInTextLogo}></IonImg></IonTitle>
                    <IonButtons slot='end'>
                        <IonMenuButton color={'tertiary'} />
                    </IonButtons>
                </IonToolbar>
            </IonHeader>
            <IonContent className='ion-padding account-content-bg'>
                <IonRow>
                    <IonCol size='12'>
                        <h1><IonIcon color={'secondary'} icon={optionsOutline}></IonIcon> My Settings<br /><span>Manage your settings & preferences</span></h1>
                    </IonCol>
                </IonRow>

                <IonAccordionGroup className='ion-margin-top' ref={accordionGroup} {...(levelOpen ? { value: 'level' } : {})}>

                    <IonAccordion value="theme">
                        <IonItem slot="header">
                            <IonLabel>Color Mode</IonLabel>
                        </IonItem>
                        <div slot="content">
                            <IonCard>
                                <IonCardContent>
                                    <IonItem lines='none'>
                                        <IonToggle checked={settings.theme == '1'} color={'success'} id='themeToggle' justify="space-between" onIonChange={updateSetting}>
                                            Light / Dark
                                        </IonToggle>                                        
                                    </IonItem>
                                    <IonItem lines='none'>
                                        <p><IonText>Dark mode can help save battery life.</IonText></p>
                                    </IonItem>
                                </IonCardContent>
                            </IonCard>                            
                        </div>
                    </IonAccordion> 

                    {level?.memberLevelID >= '2' &&
                        (<IonAccordion value="menu">
                            <IonItem slot="header">
                                <IonLabel>Customize Profiles Menu</IonLabel>
                            </IonItem>
                            <div slot="content">
                                <IonCard>
                                    <IonCardContent>
                                        <IonItem lines='none'>
                                            <p><IonText>Select which additional modules to include in your account menu. They're all included with your membership, but for some of you, these are unnecessary clutter.</IonText></p>
                                        </IonItem>
                                        <IonItem lines='none'>
                                            <IonToggle checked={settings.menuKids == '1'} color={'success'} enableOnOffLabels={true} id='menuKidsToggle' justify="space-between" onIonChange={updateSetting}>
                                                My Kids
                                            </IonToggle>                                        
                                        </IonItem>
                                        
                                        <IonItem lines='none'>
                                            <IonToggle checked={settings.menuPartners == '1'} color={'success'} enableOnOffLabels={true} id='menuPartnersToggle' justify="space-between" onIonChange={updateSetting}>
                                                My Partners
                                            </IonToggle> 
                                        </IonItem>
                                        
                                        <IonItem lines='none'>
                                            <IonToggle checked={settings.menuPets == '1'} color={'success'} enableOnOffLabels={true} id='menuPetsToggle' justify="space-between" onIonChange={updateSetting}>
                                                My Pets
                                            </IonToggle> 
                                        </IonItem>
                                        <IonItem lines='none'>
                                            <IonToggle checked={settings.menuVehicles == '1'} color={'success'} enableOnOffLabels={true} id='menuVehiclesToggle' justify="space-between" onIonChange={updateSetting}>
                                                My Vehicles
                                            </IonToggle> 
                                        </IonItem>
                                    </IonCardContent>
                                </IonCard>                            
                            </div>
                        </IonAccordion>)
                    }

                    {level?.memberLevelID >= '3' &&
                        (<IonAccordion value="searchable">
                            <IonItem slot="header">
                                <IonLabel>My Profile Visibility</IonLabel>
                            </IonItem>
                            <div slot="content">
                                <IonCard>
                                    <IonCardContent>
                                        <IonItem lines='none'>
                                            <IonToggle checked={authorizedMember.memberSearchable == '1'} color={'success'} enableOnOffLabels={true} id='searchableToggle' justify="space-between" onIonChange={updateSetting}>
                                                Hide / Show
                                            </IonToggle>                                      
                                        </IonItem>
                                        <IonItem lines='none'>
                                            <p><IonText>This applies to visibility in Partner search results.</IonText></p>
                                        </IonItem>
                                    </IonCardContent>
                                </IonCard>                            
                            </div>
                        </IonAccordion>)
                    }

                    <IonAccordion value="delay">
                        <IonItem slot="header">
                            <IonLabel>Default Timer Alarm Delay</IonLabel>
                        </IonItem>
                        <div slot="content">
                            <IonCard>
                                <IonCardContent>
                                    <IonItem lines='none'>
                                        <IonSelect label='Select a Period:' labelPlacement='start' id='delaySelect' onIonChange={updateSetting} value={settings.delay === undefined ? '0' : settings.delay}>
                                            <IonSelectOption value='0'>No delay</IonSelectOption>
                                            <IonSelectOption value='0.25'>15 minutes</IonSelectOption>
                                            <IonSelectOption value='0.5'>30 minutes</IonSelectOption>
                                            <IonSelectOption value='1'>1 hour</IonSelectOption>
                                            <IonSelectOption value='2'>2 hours</IonSelectOption>
                                            <IonSelectOption value='3'>3 hours</IonSelectOption>
                                            <IonSelectOption value='6'>6 hours</IonSelectOption>
                                            <IonSelectOption value='12'>12 hours</IonSelectOption>
                                            <IonSelectOption value='24'>24 hours</IonSelectOption>
                                        </IonSelect>                                      
                                    </IonItem>
                                    <IonItem lines='none'>
                                        <p><IonText>This default setting applies to new Timers only and can be overridden when creating a new Timer.</IonText></p>
                                    </IonItem>
                                </IonCardContent>
                            </IonCard>                            
                        </div>
                    </IonAccordion>

                    {platform === 'web' &&
                    <IonAccordion value="push">
                        <IonItem slot="header">
                            <IonLabel>Web Push Notifications</IonLabel>
                        </IonItem>
                        <div slot="content">
                            <IonCard>
                                <IonCardContent>
                                    <IonList>
                                        <IonItem lines='none'>
                                            <IonLabel class="ion-text-wrap">
                                                    <p><IonText color={'dark'}>By selecting this option, you are agreeing to receive push notifications from SoloWise, for the sole purpose of reminding you to check-in at your pre-scheduled times. You will never receive push notifications of a marketing or advertising nature from us. Consent is not a condition of your account usage. Please open and read the following policies for more details. You can opt-out of receiving push notifications by de-selecting this option.</IonText></p>                                                   
                                                    <ul>
                                                        <li className='link' id='privacyLink'><Link to={'/privacy-policy'} dir='forward'>Read our Privacy Policy</Link></li>
                                                        <li className='link' id='termsLink'><Link to={'/terms-conditions-policy'} dir='forward'>Read our Terms and Conditions of Use Policy</Link></li>                                            
                                                    </ul>
                                                </IonLabel>                            
                                        </IonItem>
                                        <IonItem lines='none'>
                                            <IonToggle checked={sub !== null} color={'success'} enableOnOffLabels={true} id='pushToggle' justify="space-between" onIonChange={sub === null ? subscribe : unsubscribe} disabled={pushPermStr === 'denied'}>
                                                I want to receive Web Push notifications
                                            </IonToggle>                                                                      
                                        </IonItem>
                                        <IonItem lines='none'>
                                            <IonText><em>Web Push notifications must be set for each separate device and web browser on which you use SoloWise.</em></IonText>
                                        </IonItem>                                          

                                        {pushPermStr === 'denied' &&
                                        <IonItem lines='none'>                                            
                                            <IonNote color={'warning'}>Your current web browser is blocking SoloWise push notifications. You must enable push notifications in your browser before subscribing to SoloWise push notifications.</IonNote>                                              
                                        </IonItem>
                                        }  
                                        {/*<div style={{ display: 'grid', gap: 8 }}>
                                            {<IonButton onClick={subscribe}>Subscribe to Push</IonButton>
                                            <IonButton onClick={unsubscribe}>Unsubscribe</IonButton>}
                                            {error && <div style={{color:'crimson'}}>Error: {error}</div>}
                                            <pre style={{maxWidth:700, whiteSpace:'pre-wrap'}}>
                                                {sub ? JSON.stringify(sub.toJSON(), null, 2) : 'No subscription'}
                                            </pre>
                                        </div>*/}
                                    </IonList>
                                </IonCardContent>
                            </IonCard>                            
                        </div>
                    </IonAccordion>
                    }

                    <IonAccordion value="sms">
                        <IonItem slot="header">
                            <IonLabel>Text Message Permission</IonLabel>
                        </IonItem>
                        <div slot="content">
                            <IonCard>
                                <IonCardContent>
                                    <IonList>
                                        <IonItem lines='none'>
                                            {authorizedMember.memberPhone == ''
                                                ? (<p><IonText color={'dark'}>You need to enter your mobile phone number under <Link to={'/account/me'}><IonText color={'secondary'}>My Account / Me / Contact</IonText></Link>.</IonText></p>)
                                                : (<IonLabel class="ion-text-wrap">
                                                    <p><IonText color={'dark'}>This agreement applies to your mobile phone number: <strong>{authorizedMember.memberPhone}</strong>.</IonText></p>
                                                    <p><IonText color={'dark'}>By selecting this option, you are agreeing to receive text messages from SoloWise, for the sole purpose of reminding you to check-in at your pre-scheduled times. You will never receive text messages of a marketing or advertising nature from us. Consent is not a condition of your account usage. Message/data rates from your carrier may apply. Please open and read the following policies for more details. You can opt-out of receiving text messages by de-selecting this option, or you can reply UNSUBSCRIBE or OPT-OUT to our system.</IonText></p>         
                                                    <ul>
                                                        <li className='link' id='privacyLink'><Link to={'/privacy-policy'} dir='forward'>Read our Privacy Policy</Link></li>
                                                        <li className='link' id='termsLink'><Link to={'/terms-conditions-policy'} dir='forward'>Read our Terms and Conditions of Use Policy</Link></li>                                            
                                                    </ul>
                                                </IonLabel>)
                                            }                                            
                                        </IonItem>
                                        
                                        <IonItem>                    
                                            <IonToggle 
                                                checked={authorizedMember.memberSMSAgree == '1'} 
                                                color={'success'} 
                                                disabled={authorizedMember.memberPhone == ''}
                                                enableOnOffLabels={true} 
                                                id='smsToggle' 
                                                onIonChange={updateSetting} 
                                                 style={{'flex': 'none', 'minWidth': '50px', 'width': '10%'}}>
                                            </IonToggle> 
                                            <IonLabel><strong>I want to receive text messages</strong></IonLabel>              
                                        </IonItem>
                                        <IonItem className='ion-padding-top' lines='none'>                    
                                            <p><strong><em>Members outside the U.S.</em></strong> might require additional configuration to receive text messages. If you or your contacts find that you are not receiving text messages when expected, contact our support team right away for assistance.</p> 
                                        </IonItem>
                                        
                                    </IonList>
                                </IonCardContent>
                            </IonCard>                            
                        </div>
                    </IonAccordion>

                    <IonAccordion value="geoloc">
                        <IonItem slot="header">
                            <IonLabel>Location Access Permission</IonLabel>
                        </IonItem>
                        <div slot="content">
                            <IonCard>
                                <IonCardContent className='ion-padding-top'>
                                    <p><IonText color={'dark'}>Current Status:</IonText> <IonText color={locationPermStr == 'Denied' ? 'warning' : 'success'}><strong>{locationPermStr}</strong></IonText></p>
                                    <hr />
                                    <p>This setting is primarily controlled by either your web browser (in the case you are using SoloWise on the Web) or your device's operating system (in the case you are using Solowise as an iPhone or Android app).</p>
                                    
                                    {/*locationPerm === 'Prompt' 
                                        ? (<>
                                            <p>If your current location permission status is "Prompt", and you would like to change that status, you can try tapping the button below to access those settings.</p>
                                            <IonButton onClick={requestLocationPerms}>
                                                Manage Location Permission
                                            </IonButton>
                                           </>)
                                        : (<p>If your current location permission status is either "Granted" or "Denied", and you would like to change that status, it must be managed directly through either your web browser settings or the mobile app settings, depending on your use case.</p>)
                                    */}     

                                    <p><IonButton color={'remove'} size='small' fill='outline' onClick={deleteLocations} ref={deleteLocsBtn}>Delete all saved locations</IonButton></p>                         
                                </IonCardContent>
                            </IonCard>                            
                        </div>
                    </IonAccordion>

                    <IonAccordion value="password">
                        <IonItem slot="header">
                            <IonLabel>Reset Your Account Passcode</IonLabel>
                        </IonItem>
                        <div slot="content">
                            <IonCard>
                                <IonCardContent>
                                   
                                    <p>First, verify your <strong>current</strong> passcode.</p>
                                    <IonItem className='item-label' lines='none'>
                                        <IonInput className='ion-margin-top' fill='outline' label='Enter your current passcode' labelPlacement='floating' ref={passcodeVerifyInput} type='password'>
                                            <IonInputPasswordToggle color={'dark'} slot="end"></IonInputPasswordToggle>
                                        </IonInput>
                                    </IonItem>
                                    <IonItem className='ion-margin-bottom' lines='none'>
                                        <IonButton color={'secondary'} onClick={verifyReset} ref={passcodeVerifyBtn} size='default'>Verify</IonButton>
                                    </IonItem>
                                           
                                    { resetVerified 
                                        ? (<>
                                            <p><IonText color={'success'}>OK, now, enter a <strong>new</strong> passcode. It must be at least 8 letters, numbers, or other characters.</IonText></p>
                                            <IonItem className='item-label' lines='none'>
                                                <IonInput className='ion-margin-top' fill='outline' ref={passcodeInput} label='Enter a new passcode' labelPlacement='floating' onKeyUp={validateReset} type='password'>
                                                    <IonInputPasswordToggle color={'dark'} slot="end"></IonInputPasswordToggle>
                                                </IonInput>
                                            </IonItem>
                                            <IonItem lines='none'>
                                                <IonButton color={'secondary'} id='passwordSet' onClick={confirmPasscodeReset} size='default' disabled={disableReset}>Save</IonButton>
                                            </IonItem>
                                           </>)
                                        : (<></>)
                                    }
                                </IonCardContent>
                            </IonCard>                            
                        </div>
                    </IonAccordion>
                
                    <IonAccordion value="tech">
                        <IonItem slot="header">
                            <IonLabel>Tech Info</IonLabel>
                        </IonItem>
                        <div slot="content">
                            <IonCard>
                                <IonCardContent>
                                    <IonText color={'dark'}><p><strong>SoloWise App</strong></p></IonText>
                                    <div className='ion-padding-start ion-padding-end'>
                                        <IonLabel><strong>Version</strong></IonLabel>
                                        <p>2.0.6</p>
                                        <IonLabel><strong>Build</strong></IonLabel>
                                        <p>20261029.1</p>
                                        <IonLabel onClick={getAppStatus}><strong>Connection Status <IonIcon icon={refreshOutline}></IonIcon></strong></IonLabel>
                                        <p><IonIcon color={appStatusColor} icon={discSharp} style={{verticalAlign: 'middle'}}></IonIcon> {appStatus}</p>
                                    </div>
                                    <hr />
                                    <IonText color={'dark'}><p><strong>Device</strong></p></IonText>
                                    <div className='ion-padding-start ion-padding-end'>
                                        <IonLabel><strong>Platform</strong></IonLabel>
                                        <p>{formatPlatform(platform)}</p>
                                        <IonLabel><strong>Model</strong></IonLabel>
                                        <p>{model}</p>
                                        <IonLabel><strong>OS</strong></IonLabel>
                                    <p>{os}</p>
                                    </div>
                                    <hr />
                                    <IonText color={'dark'}><p><strong>Network</strong></p></IonText>
                                    <div className='ion-padding-start ion-padding-end'>
                                        <IonLabel><strong>Type</strong></IonLabel>
                                        <p>{networkType}</p>
                                        <IonLabel><strong>Status</strong></IonLabel>
                                        <p><IonIcon color={networkStatusColor} icon={discSharp} style={{verticalAlign: 'middle'}}></IonIcon> {networkStatus ? 'Online' : 'Offline'}</p>
                                    </div>
                                    <hr />
                                    <IonText color={'dark'}><p><strong>Legal & Support Links</strong></p></IonText>
                                    <ul>
                                        <li className='link' id='privacyLink'><Link to={'/privacy-policy'} dir='forward'>Privacy Policy</Link></li>
                                        <li className='link' id='termsLink'><Link to={'/terms-conditions-policy'} dir='forward'>Terms and Conditions of Use Policy</Link></li>
                                        <li className='link' id='supportLink'><Link to={'/account/support'} dir='forward'>Tech Support</Link></li>                                            
                                    </ul>
                                </IonCardContent>
                            </IonCard>
                        </div>
                    </IonAccordion>

                    <IonAccordion value="delete">
                        <IonItem slot="header">
                            <IonLabel color={'remove'}>Delete Your Account</IonLabel>
                        </IonItem>
                        <div slot="content">
                            <IonCard>
                                <IonCardContent>
                                    <p><IonText color={'remove'}>Verify your current passcode to DELETE your account. Deleting your account is final. <strong>There is no undo.</strong></IonText></p>
                                    <IonItem className='item-label' lines='none'>
                                        <IonInput className='ion-margin-top' fill='outline' label='Enter your passcode' labelPlacement='floating' ref={deleteInput} type='password'>
                                            <IonInputPasswordToggle color={'dark'} slot="end"></IonInputPasswordToggle>
                                        </IonInput>
                                    </IonItem>
                                    <IonItem lines='none'>
                                        <IonButton color={'secondary'} onClick={verifyDelete} ref={deleteVerify} size='default'>Verify</IonButton>
                                        <IonButton color={'remove'} onClick={deleteAccount} ref={accountDelete} size='default' disabled={disableDelete}>DELETE ACCOUNT</IonButton>
                                    </IonItem>
                                </IonCardContent>
                            </IonCard>                            
                        </div>
                    </IonAccordion>

                </IonAccordionGroup>

            </IonContent>
        </IonPage>
    );
};

export default Settings;